/***
 **Module Name: category
 **File Name :  category.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains category page details.
 ***/
import React, { useState, useEffect, useRef, useContext } from "react";
import tmdbApi from "../../api/tmdbApi";
import { useNavigate } from "react-router";
import axios from 'axios';
import { useForm } from "react-hook-form";
import SessionPopup from "../SessionPopup"
import Select from 'react-select';
import { getCompanies } from "../../utils/reducer";
import { contentContext } from "../../context/contentContext";

import Modal from 'react-bootstrap/Modal';
let { lambda, appname } = window.app;

const AdvanceSearch = (props) => {
  const navigate = useNavigate();
  const { control, handleSubmit } = useForm();
  const [menus, setMenus] = useState([]);
  // const [data, setData] = useState([]);
  const [content, setContent] = useState("");

  const [categoryError, setCategoryError] = useState("");
  const [loaderEnable, setLoaderEnable] = useState(false);
  const [errorMsg, setErrorMsg] = useState({});

  // const [selectedOptions, setSelectedOptions] = useState([]);

  // const [selectedOptionsClientName, setSelectedOptionsClientName] = useState([]);
  const [companiesData, setCompaniesData] = useState([]);
  const [companiesLoading, setCompaniesLoading] = useState(false);
  const [accountManagers, setAccountManagers] = useState([]);

  const [lookup, setLookUp] = useState({});



  const [showSessionPopupup, setShowSessionPopupup] = useState(false);


  const { popup, setShowPopup, excludeSelected, setExcludeSelected, isCompanyManuallyChanged, setIsCompanyManuallyChanged, genreExcludeSelected, setGenreExcludeSelected, handleClosePopup, selectedItems, isChecked1, setIsChecked1, setSelectedItems, searchExport, setSearchExport, initialData, Categories, searchData, SetSearchData, catBasedContentFields, categoryName, setCategoryName, categoryNameAdv, setCategoryNameAdv, initialCategoriesData1, setInitialCategoriesData1, hideMenu, setHideMenu, clientData1, searchPayload, setSearchPayload, selectedOptions, setSelectedOptions, selectedOptionsClientName, setSelectedOptionsClientName, multiSelectFields, setMultiSelectFields, activeFieldsObj, searchable, setSearchable, setActiveFieldsObj, setContentSearch, route, setRoute, setCurrentPage, setRowsPerPage, usePrevious, setData, GetTimeActivity, totalRows, rowsPerPage, currentPageNew, setTotalRows, accountManagerId, setAccountManagerId, } = useContext(contentContext)

  const prevRoute = usePrevious(route)
  useEffect(() => {
    if (prevRoute != undefined && prevRoute != route) {
      setCurrentPage(1)
      setRowsPerPage(15)
    }
  }, [prevRoute]);
  useEffect(() => {
    setRoute("content")
    if (!searchPayload?.accountmanagername) {
      Companies(undefined, false, true); // load companies list by default only when no account manager is selected
    }
  }, []);
  console.log('selectedOptionsClientName', selectedOptionsClientName)

  const Companies = async (Id, isExplicitChange = false, onlyLoadOptions = false) => {
    setCompaniesLoading(true);
    const token = localStorage.getItem("token");
    const userid = localStorage.getItem("userId");

    let obj = { sortby: 'companyname' };

    if (Id) {
      obj.accountManagerId = Id;
    }

    try {
      const response = await axios({
        method: 'POST',
        url: `${lambda}/companies?appname=${appname}&token=${token}&userid=${userid}`,
        data: obj
      });

      const result = response?.data?.result;

      if (result === "Invalid token or Expired") {
        setShowSessionPopupup(true);
        return;
      }

      const data = result?.data || [];

      // Always update dropdown options so the list is populated
      setCompaniesData(data);

      // If only loading options for the default dropdown, stop here
      if (onlyLoadOptions) return;

      setAccountManagerId(Id);

      const formattedOptions = data.map(item => ({
        value: item.companyid,
        label: item.companyname
      }));

      // Override selection only when:
      // - user explicitly changed the account manager (isExplicitChange = true), OR
      // - user has NOT manually customised the company list
      if (isExplicitChange || !isCompanyManuallyChanged) {
        setSelectedOptionsClientName(formattedOptions);
        if (isExplicitChange) setIsCompanyManuallyChanged(false);

        const companyIds = formattedOptions.map(item =>
          Array.isArray(item.value) ? item.value[0] : item.value
        );

        setSearchPayload(prev => ({
          ...prev,
          companyid: companyIds
        }));
      }

    } catch (error) {
      console.log(error);
    } finally {
      setCompaniesLoading(false);
    }
  };
  const AccountManagers = async (e) => {

    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")

    let obj = { sortby: 'companyname' }
    axios({
      method: 'GET',
      url: lambda + '/accountmangers?appname=' + appname + "&token=" + token + "&userid=" + userid,
      // data: obj
    })
      //  const response = await tmdbApi.getAccount({
      //             });
      .then(function (response) {
        console.log("response", response?.data?.result);
        if (response?.data?.result == "Invalid token or Expired") {
          setShowSessionPopupup(true)
        } else {
          setAccountManagers(response?.data?.result);
        }
      }).catch((error) => {
        console.log(error);
      });
  }

  // const returnArray = (arr) => {
  //   let arr2 = []
  //   arr.map((eachItem) => {
  //     arr2.push(eachItem.value)
  //   })
  //   return arr2
  // }
  const returnArray = (arr) => {
    if (!arr) return [];

    // multi select
    if (Array.isArray(arr)) {
      return arr.map(item => item.value);
    }

    // single select
    return [arr.value];
  };
  const singleArray = (arr) => {
    let arr2 = []

    arr2.push(arr.value)
    return arr2
  }


  const handleChange = (selected, key) => {
    console.log('selectedOptions', selected)
    setErrorMsg({})
    searchPayload['noofepisodes'] = {}
    let selectedArray = returnArray(selected)
    setIsCompanyManuallyChanged(false);

    setSearchable(false)
    setActiveFieldsObj({ CookingshowActive: false, seriesActive: false, SportsActive: false, MusicActive: false, LiveEventActive: false })

    if (selectedArray.length > 0) {
      const selectedLastValue = selected[selected.length - 1]
      const selectedValue = selectedLastValue?.value;
      const data = catBasedContentFields?.filter(item => item.name === selectedValue);
      const filterField = data?.[0]?.fields?.filter(item => item.name === "noofepisodes");
      console.log("filterField", filterField)
      if (filterField?.[0]?.searchable === true) {

        setSearchable(true);
      }
      console.log("selected", selected[selected.length - 1])

      selectedArray.forEach((eachItem) => {
        if (eachItem === 'LIFESTYLE') setActiveFieldsObj({ ...activeFieldsObj, CookingshowActive: true })
        if (eachItem === 'SPORTS') setActiveFieldsObj({ ...activeFieldsObj, SportsActive: true })
        if (eachItem === 'LIVE EVENTS') setActiveFieldsObj({ ...activeFieldsObj, LiveEventActive: true })
        if (eachItem === 'MUSIC') setActiveFieldsObj({ ...activeFieldsObj, MusicActive: true })
        if (eachItem === 'SERIES & TELENOVELAS') setActiveFieldsObj({ ...activeFieldsObj, seriesActive: true })

      })

    }


    if (key === "accountmanagername") {
      const managerId = selected?.value;
      setCompaniesLoading(true);
      setTimeout(() => Companies(managerId, true), 0);

      // send string directly
      searchPayload[key] = selected ? selected.label : "";
    } else {
      //  use common function
      const selectedArray = returnArray(selected);
      searchPayload[key] = selectedArray;
    }

    // searchPayload['category'] = selectedArray
    setCategoryError("")
    setSearchPayload({ ...searchPayload })
    setSelectedOptions(selected);

  };


  const handleMultiSelect = (selected, key) => {
    setRowsPerPage(15)
    setCurrentPage(1)
    GetTimeActivity()
    console.log('selectedOptions', selected)

    let selectedArray = returnArray(selected)
    setMultiSelectFields({ ...searchPayload, [key]: selectedArray })
    setSearchPayload({ ...searchPayload, [key]: selectedArray })


  };

  useEffect(() => {
    if (Object.keys(searchPayload).length == 0) {
      const elements = document.getElementsByClassName('for-clear');
      for (let i = 0; i < elements.length; i++) {
        elements[i].value = '';
      }
      setMultiSelectFields([])
      // setSelectedOptions([])
    }
  }, [searchPayload]);
  useEffect(() => {
    if (searchPayload?.accountmanagername) {
      Companies(accountManagerId);
    } 
  }, []);

  const selectAllOption = { label: "Select All", value: "__all__" };

  const companyOptions = Array.isArray(companiesData)
    ? companiesData.map(item => ({
      label: item.companyname,
      value: item.companyid
    }))
    : [];

  const selectedCompanyIds = new Set(
    (selectedOptionsClientName || []).map(item => String(item.value))
  );
  const filteredCompanyOptions = companyOptions.filter(
    item => !selectedCompanyIds.has(String(item.value))
  );
  const finalCompanyOptions = [selectAllOption, ...filteredCompanyOptions];
  console.log('finalCompanyOptions', finalCompanyOptions)
  // const handleChangeClientName = (selected) => {
  //   setRowsPerPage(15)
  //   setCurrentPage(1)
  //   GetTimeActivity()
  //   let selectedArray = singleArray(selected)
  //   searchPayload['companyid'] = selected.value
  //   setSearchPayload({ ...searchPayload })
  //   setSelectedOptionsClientName(selected);
  // };
  const handleChangeClientName = (selected) => {
    setRowsPerPage(15);
    setCurrentPage(1);
    GetTimeActivity();
    setIsCompanyManuallyChanged(true);

    // Single select mode when no account manager is selected
    if (!searchPayload.accountmanagername) {
      const finalSelected = selected ? [selected] : [];
      const companyIds = finalSelected.map(item =>
        Array.isArray(item.value) ? item.value[0] : item.value
      );
      setSearchPayload(prev => ({ ...prev, companyid: companyIds }));
      setSelectedOptionsClientName(finalSelected);
      return;
    }

    // Multi select mode when account manager is selected
    const isSelectAll = (selected || []).some(
      (option) => option.value === "__all__"
    );

    let finalSelected = selected || [];

    if (isSelectAll) {
      if (selectedOptionsClientName?.length === companyOptions.length) {
        finalSelected = [];
      } else {
        finalSelected = companyOptions;
      }
    }

    // FORCE FLAT ARRAY
    const companyIds = finalSelected.map(item =>
      Array.isArray(item.value) ? item.value[0] : item.value
    );

    setSearchPayload(prev => ({
      ...prev,
      companyid: companyIds
    }));

    setSelectedOptionsClientName(finalSelected);
  };
  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/");
    }
    Categories();
    AccountManagers()
    // GetLookUp();
    GetLookUp2();
    setInitialCategoriesData1([]);
  }, []);

  // Assuming catBasedContentFields is an array of objects with a fields property

  const searchSubmit = async () => {
    GetTimeActivity()
    const isValid = validateSearchData();
    if (isValid) {
      try {
        setLoaderEnable(true)

        if (activeFieldsObj.LiveEventActive == false && activeFieldsObj.MusicActive == false) {
          // console.log('!LiveEventActive && !MusicActive')
          if (searchPayload.hasOwnProperty('bandname')) delete searchPayload['bandname']
          if (searchPayload.hasOwnProperty('lyricist')) delete searchPayload['lyricist']
          if (searchPayload.hasOwnProperty('otherartists')) delete searchPayload['otherartists']
          if (searchPayload.hasOwnProperty('performancetype')) delete searchPayload['performancetype']
          if (searchPayload.hasOwnProperty('leadartist')) delete searchPayload['leadartist']
          if (searchPayload.hasOwnProperty('musicgenre')) {
            delete searchPayload['musicgenre']
            setMultiSelectFields({ ...multiSelectFields, musicgenre: [] })
          }
        }
        if (activeFieldsObj.SportsActive == false && activeFieldsObj.LiveEventActive == false) {
          if (searchPayload.hasOwnProperty('sportsstars')) delete searchPayload['sportsstars']
          if (searchPayload.hasOwnProperty('sport')) {
            setMultiSelectFields({ ...multiSelectFields, sport: [] })
            delete searchPayload['sport']
          }
        }
        if (activeFieldsObj.CookingshowActive == false) {
          if (searchPayload.hasOwnProperty('anchor')) delete searchPayload['anchor']
          if (searchPayload.hasOwnProperty('chef')) delete searchPayload['chef']
          if (searchPayload.hasOwnProperty('cuisine')) {
            setMultiSelectFields({ ...multiSelectFields, cuisine: [] })
            delete searchPayload['cuisine']
          }
          if (searchPayload.hasOwnProperty('mealtype')) delete searchPayload['mealtype']
        }
        if (activeFieldsObj.SportsActive == false) {
          if (searchPayload.hasOwnProperty('league_tournament')) delete searchPayload['league_tournament']
        }

        if (searchable === false) {
          if (searchPayload.hasOwnProperty('noofepisodes')) delete searchPayload['noofepisodes']
        }
        if (searchPayload.hasOwnProperty('status')) {
          if (searchPayload['status'] === "") {
            delete searchPayload['status']
          }
        }
        if (searchPayload.hasOwnProperty('languages')) {
          searchPayload['dubbinglanguages'] = searchPayload.languages
        }
        if (searchPayload.hasOwnProperty('languagesNot')) {
          searchPayload['dubbinglanguagesNot'] = searchPayload.languagesNot
        }
        if (searchPayload.hasOwnProperty('featured')) {
          if (searchPayload['featured'] === "") {
            delete searchPayload['featured']
          }
        }
        if (Array.isArray(searchPayload.categoryNot) && searchPayload.categoryNot.length === 0) {
          delete searchPayload.categoryNot;
        }
        if (Array.isArray(searchPayload.languagesNot) && searchPayload.languagesNot.length === 0) {
          delete searchPayload.languagesNot;
          delete searchPayload.dubbinglanguagesNot;
        }
        if (Array.isArray(searchPayload.typeofrights) && (searchPayload.typeofrights.includes('AVOD') ||
          searchPayload.typeofrights.includes('SVOD') ||
          searchPayload.typeofrights.includes('TVOD'))) {
          searchPayload['typeofrights'] = [...new Set([...searchPayload.typeofrights, "Digital", "OTT"])];
        } else
          if (Array.isArray(searchPayload.typeofrights) && (searchPayload.typeofrights.includes('Digital') ||
            searchPayload.typeofrights.includes('OTT'))) {
            searchPayload['typeofrights'] = [...new Set([...searchPayload.typeofrights, "OTT", "AVOD", "SVOD", "TVOD", "Digital"])];
          }

        let arrayType = ["country", "genre", "videoformat", "resolution", "musicgenre", "rights", "cuisine", "sport", "certificate", "category", "typeofrights", "videoquality", "cast", "director", "countryorigin", "territoriesavailable", "languages", "subtitleslanguages", "dubbinglanguages"];
        var flag = true
        let isCategoryAvailable = searchPayload.hasOwnProperty('category')
        console.log('isCategoryAvailable', isCategoryAvailable)
        console.log("arraytype", arrayType)
        arrayType.forEach((eachItem) => {
          if (searchPayload.hasOwnProperty(eachItem)) {
            // console.log('eachiitemeemememme',eachItem)
            if (searchPayload[eachItem].length <= 0)
              delete searchPayload[eachItem]
          }
        })
        let arrayType2 = ["releaseyear", "bandname", "IMDBrating", "sportsstars", "title"];
        arrayType2.forEach((eachItem) => {
          if (searchPayload.hasOwnProperty(eachItem)) {
            if (searchPayload[eachItem] === "")
              delete searchPayload[eachItem]
          }
        })


        const updatedObject = Object.fromEntries(
          Object.entries(searchPayload).filter(([_, value]) => {
            if (Array.isArray(value)) {
              return value[0] !== '';
            } else {
              return value !== '';
            }
          })
        );
        if (typeof updatedObject.companyid === 'string') {
          updatedObject.companyid = [updatedObject.companyid];
        }

        setSearchPayload(updatedObject)



        const token = localStorage.getItem("token")
        const userid = localStorage.getItem("userId")
        const linkUrl = `${lambda}/content?appname=${appname}&token=${token}&userid=${userid}&pageNumber=${currentPageNew}&assetcount=${rowsPerPage}`

        axios({
          method: 'POST',
          url: linkUrl,
          data: updatedObject
        })
          .then(function (response) {
            if (response?.data?.result == "Invalid token or Expired") {
              setShowSessionPopupup(true)
            } else {
              const dataArray = Object.values(response?.data?.result?.data).map((obj) => obj);
              if (dataArray.length > 0) {
                setSearchExport(true);
                setSelectedItems([])
                setIsChecked1(false)
              } else {
                setSearchExport(false); // Optionally, handle the case where the array is empty
              }
              setData(dataArray)


              // let data = response?.result && response?.result.data && response?.result.data.length > 0 ? response?.result.data : []

              setInitialCategoriesData1(dataArray);
              setShowPopup(false);
              setContentSearch("");
              props.onData(updatedObject);


              setCurrentPage(1)
              setTotalRows(response?.data?.result?.totalContent)
              setRowsPerPage(15)
              //    if(data.length<=0){
              //      setData(data)
              //    }

            }
            setLoaderEnable(false)
          });



        // const response = await tmdbApi.filterCategory(updatedObject);

        // console.log("searchPayload response", response?.result);
        // if (response?.result == "Invalid token or Expired") {
        //   setShowSessionPopupup(true)
        // } else {
        //   let data = response?.result && response?.result.data && response?.result.data.length > 0 ? response?.result.data : []

        //   setInitialCategoriesData1(data);
        //   setShowPopup(false);
        //   setContentSearch("");
        //   props.onData(updatedObject);
        //   setCurrentPage(1)
        //   setTotalRows(response?.result?.data?.totalContent)
        //   setRowsPerPage(15)
        //   if(data.length<=0){
        //     setData(data)
        //   }
        // }

      }
      catch {
        setLoaderEnable(false)
        console.log("error");
      }
    }

  }

  const validateSearchData = () => {
    let formIsValid = true;
    let error = { ...errorMsg };

    if (parseInt(searchPayload.noofepisodes?.noofepisodesfrom) >= parseInt(searchPayload.noofepisodes?.noofepisodesto)) {
      error['noofepisodesfrom'] = `Max value should be greater than the min value`;

      formIsValid = false;
    }


    setErrorMsg(error);
    return formIsValid;
  };

  const reactSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      pointerEvents: 'auto',
    }),
    valueContainer: (provided) => ({
      ...provided,
      overflowX: 'auto',
      overflowY: 'hidden',
      whiteSpace: 'nowrap',
      flexWrap: 'nowrap',
    }),
    multiValue: (provided) => ({
      ...provided,
      flex: '0 0 auto',
      whiteSpace: 'nowrap',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: 180,
      overflowY: 'auto',
      overflowX: 'auto',
    }),
  };
  const onChangeSearch = (e) => {
    setRowsPerPage(15)
    setCurrentPage(1)
    if (e.target.name === "featured" || e.target.name === "videoAvailable") {
      if (e.target.value === "true") {
        setSearchPayload({ ...searchPayload, [e.target.name]: true })
      } else if (e.target.value === "false") {
        setSearchPayload({ ...searchPayload, [e.target.name]: false })
      }
      else {
        setSearchPayload({ ...searchPayload, [e.target.name]: e.target.value })
      }

    } else if (e.target.name === "IMDBrating") {
      const regex = /^[0-9]+(\.[0-9]{0,1})?$/
      if (e.target.value === '' || (regex.test(e.target.value) && parseFloat(e.target.value) <= 10 && parseFloat(e.target.value) >= 1)) {
        setSearchPayload({ ...searchPayload, [e.target.name]: e.target.value });
      }

    }
    else if (e.target.name === "releaseyear") {
      const regex = /^[0-9\b]+$/;
      if (e.target.value === "" || regex.test(e.target.value)) {
        setSearchPayload({ ...searchPayload, [e.target.name]: e.target.value })
      }


    } else if (e.target.name === "noofepisodesfrom" || e.target.name === "noofepisodesto") {
      setErrorMsg({})
      const regex = /^[0-9]+(\.[0-9]{0,1})?$/;
      if (e.target.value === "" || regex.test(e.target.value)) {

        const updatedObject = {
          ...searchPayload,
          noofepisodes: {
            ...searchPayload.noofepisodes,
            [e.target.name]: e.target.value
          }
        };
        setSearchPayload(updatedObject);
      }



      // if (!updatedObject.noofepisodes.noofepisodesfrom && !updatedObject.noofepisodes.noofepisodesto) {
      //   delete updatedObject.noofepisodes;
      // }
    } else if (e.target.name === "status") {
      if (e.target.value == "") {
        if (searchPayload.hasOwnProperty['status']) delete searchPayload["status"]
      }
      setSearchPayload({ ...searchPayload, [e.target.name]: [e.target.value] })
    }
    // else {
    //   delete updatedObject.noofepisodes[name];
    // }

    else {
      searchPayload[e.target.name] = e.target.value
      setSearchPayload({ ...searchPayload })
    }


  };

  console.log("searchPayload---->", searchPayload)

  const handleToggle = (e) => {
    setExcludeSelected(e.target.checked);
    console.log("Exclude Selected:", e.target.checked);
  };
  const handleGenreToggle = (e) => {
    setGenreExcludeSelected(e.target.checked);
  }
  const clearSearch = () => {
    GetTimeActivity()
    setSelectedOptions([])
    setMultiSelectFields({ dubbinglanguages: [], typeofrights: [], countryorigin: [], languages: [], typeofrights: [], genre: [], videoquality: [], certificate: [], subtitleslanguages: [], territoriesavailable: [], sport: [], musicgenre: [] })
    setActiveFieldsObj({ CookingshowActive: false, seriesActive: false, SportsActive: false, LiveEventActive: false, MusicActive: false })
    setSearchable(false)
    setExcludeSelected(false)
    setIsCompanyManuallyChanged(false);
    setGenreExcludeSelected(false)
    setSelectedOptionsClientName([])
    setAccountManagerId("")
    SetSearchData([])
    setSearchPayload({})
    Companies(undefined, false, true); // reload all companies after reset since account manager is cleared
  }
  const GetLookUp2 = async (e) => {
    try {
      let arrayType = ["country", "territories", "genre", "videoformat", "resolution", "musicgenre", "rights", "cuisine", "sports", "certificate", "language"];

      const response = await tmdbApi.getLookUp({
        type: arrayType

      });
      console.log(response);
      if (response?.statusCode == 200) {
        let arrayType = ["country", "territories", "genre", "videoformat", "resolution", "musicgenre", "rights", "cuisine", "sports", "certificate", "language"];

        let lookupsData = response?.result.data || []

        arrayType.map((eachItem) => {
          let arr1 = []
          lookupsData.map((item1) => {
            if (item1.type == eachItem) {
              arr1.push(item1.name)
            }
          });
          lookup[eachItem] = arr1
          setLookUp({ ...lookup });
        })

      }

    } catch {
      console.log("error");
    }
  }

  // console.log("ssssss", searchPayload);
  return (
    <>
      {showSessionPopupup && <SessionPopup />}



      <div className="left-block adv_search">
        {/* <div className="adv_header">
             <h6>
               <span className="material-symbols-outlined">search</span>
               Advanced Search{" "}
             </h6>
           </div> */}
        <div className="adv_body">
          <div className="adv_body-inner">
            <div className="row adv-form">
              <div className="col-md-4" style={{
                pointerEvents: searchPayload.categoryNot?.length > 0 ? "none" : "auto", opacity: searchPayload.categoryNot?.length > 0 ? 0.5 : 1,
              }}>
                <div className="form-group">
                  <div className="label-toggle">
                    <label htmlFor="example-text-input" className="col-form-label">category</label>

                    {/* <div className="d-flex align-items-center">
                       <label className="toggle-lable">Exclude Selected</label>
                      <label className="toggle">
                        <input
                          type="checkbox"
                          checked={excludeSelected}
                          disabled={searchPayload.category && searchPayload.category.length > 0 ? false : true}
                          onChange={handleToggle}
                        />
                        <span className="slider"></span>
                      </label>
                    </div> */}

                  </div>
                  <Select isMulti={true}
                    // classNamePrefix="select category"
                    placeholder='Category'
                    onChange={(e) => handleChange(e, "category")}
                    options={categoryNameAdv}
                    value={
                      searchPayload.category?.map(item => ({ value: item, label: item })) || []
                    }
                  />
                  <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{categoryError}</span>
                </div>
              </div>
              <div className="col-md-4" style={{ pointerEvents: searchPayload.category?.length > 0 ? "none" : "auto", opacity: searchPayload.category?.length > 0 ? 0.5 : 1 }}>
                <div className="form-group">
                  <div className="label-toggle">
                    <label htmlFor="example-text-input" className="col-form-label"> Exclude category</label>

                    {/* <div className="d-flex align-items-center">
                       <label className="toggle-lable">Exclude Selected</label>
                      <label className="toggle">
                        <input
                          type="checkbox"
                          checked={excludeSelected}
                          disabled={searchPayload.category && searchPayload.category.length > 0 ? false : true}
                          onChange={handleToggle}
                        />
                        <span className="slider"></span>
                      </label>
                    </div> */}

                  </div>
                  <Select isMulti={true}
                    // classNamePrefix="select category"
                    placeholder='Category'
                    onChange={(e) => handleChange(e, "categoryNot")}
                    options={categoryNameAdv}
                    // value={selectedOptions}
                    value={
                      searchPayload.categoryNot?.map(item => ({ value: item, label: item })) || []
                    }
                  />
                  <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{categoryError}</span>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label form-label">Account Manager</label>
                  <Select
                    isMulti={false}
                    placeholder='Select Accountmanager name'
                    onChange={(e) => handleChange(e, "accountmanagername")}
                    options={accountManagers && accountManagers.map((eachItem) => { return { value: eachItem.userid, label: eachItem.username } })}
                    value={
                      searchPayload.accountmanagername
                        ? {
                          value: searchPayload.userid,
                          label: searchPayload.accountmanagername
                        }
                        : null
                    }
                  />

                </div>
              </div>
              <div className="col-md-8">
                <div className="form-group">
                  <label className="form-label form-label">Company Name</label>
                  <Select
                    isMulti={!!searchPayload.accountmanagername}
                    placeholder={companiesLoading ? 'Loading companies...' : 'Select Company name'}
                    onChange={handleChangeClientName}
                    options={searchPayload.accountmanagername ? finalCompanyOptions : companyOptions}
                    value={searchPayload.accountmanagername
                      ? selectedOptionsClientName
                      : (selectedOptionsClientName[0] || null)}
                    isLoading={companiesLoading}
                    isDisabled={companiesLoading}
                    styles={reactSelectStyles}
                    loadingMessage={() => 'Loading companies...'}
                  />

                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="example-text-input" className="col-form-label">TItle</label>
                  <input
                    type="text"
                    className="form-control for-clear"
                    id="example-email-input"
                    name="title"
                    placeholder="Title"
                    value={searchPayload && searchPayload.title}
                    onChange={(e) => onChangeSearch(e)}

                  />

                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="example-text-input" className="col-form-label">country of origin</label>

                  <Select isMulti={true}

                    placeholder='Country of origin'
                    id="countryorigin"
                    className="mul-cls"
                    onChange={(e) => handleMultiSelect(e, "countryorigin")}
                    options={lookup.country && lookup.country.map((eachItem) => { return { value: eachItem, label: eachItem }; })}
                    value={multiSelectFields && multiSelectFields.countryorigin && multiSelectFields.countryorigin.length > 0 ? multiSelectFields.countryorigin?.map((eachItem) => { return { value: eachItem, label: eachItem } }) : []}
                  />

                </div>
              </div>
              {/* <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="example-text-input" className="col-form-label">country</label>
                   
                    <Select isMulti={true}
  
                      placeholder='Country'
                      id="country"
                      className="mul-cls"
                      onChange={(e) => handleMultiSelect(e, "country")}
                      options={lookup.country && lookup.country.map((eachItem) => { return { value: eachItem, label: eachItem }; })}
                      value={multiSelectFields && multiSelectFields.countryorigin && multiSelectFields.countryorigin.length > 0 ? multiSelectFields.country?.map((eachItem) => { return { value: eachItem, label: eachItem } }) : []}
                    />
                  </div>
                </div> */}
              {/* <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="example-text-input" className="col-form-label">Dubbing Languages</label>
  
                    <Select isMulti={true}
                      placeholder='Dubbing Languages'
                      className="mul-cls"
                      id='mul2'
                      onChange={(e) => handleMultiSelect(e, "dubbinglanguages")}
                      options={lookup.language && lookup.language.map((eachItem) => { return { value: eachItem, label: eachItem }; })}
                      value={multiSelectFields && multiSelectFields.dubbinglanguages && multiSelectFields.dubbinglanguages.length > 0 ? multiSelectFields.dubbinglanguages?.map((eachItem) => { return { value: eachItem, label: eachItem } }) : []}
  
                    />
                  </div>
                </div> */}
              <div className="col-md-4" style={{
                pointerEvents: searchPayload.languagesNot?.length > 0 ? "none" : "auto", opacity: searchPayload.languagesNot?.length > 0 ? 0.5 : 1,
              }}>
                <div className="form-group">
                  <label htmlFor="example-text-input" className="col-form-label">Languages (Original & Dubbed)</label>

                  <Select isMulti={true}

                    placeholder='Languages'
                    onChange={(e) => handleMultiSelect(e, "languages")}
                    options={lookup.language && lookup.language.map((eachItem) => { return { value: eachItem, label: eachItem }; })}
                    value={multiSelectFields && multiSelectFields.languages && multiSelectFields.languages.length > 0 ? multiSelectFields.languages?.map((eachItem) => { return { value: eachItem, label: eachItem } }) : []}
                  />
                </div>
              </div>
              <div className="col-md-4" style={{
                pointerEvents: searchPayload.languages?.length > 0 ? "none" : "auto", opacity: searchPayload.languages?.length > 0 ? 0.5 : 1,
              }}>
                <div className="form-group">
                  <label htmlFor="example-text-input" className="col-form-label"> Exclude Languages (Original & Dubbed)</label>

                  <Select isMulti={true}

                    placeholder='Languages'
                    onChange={(e) => handleMultiSelect(e, "languagesNot")}
                    options={lookup.language && lookup.language.map((eachItem) => { return { value: eachItem, label: eachItem }; })}
                    value={
                      searchPayload.languagesNot?.map(item => ({ value: item, label: item })) || []
                    }
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="example-text-input" className="col-form-label">Types Of Rights</label>

                  <Select isMulti={true}
                    placeholder='Types of rights'
                    onChange={(e) => handleMultiSelect(e, "typeofrights")}
                    options={lookup.rights && lookup.rights.map((eachItem) => { return { value: eachItem, label: eachItem }; })}
                    value={multiSelectFields && multiSelectFields.typeofrights && multiSelectFields.typeofrights.length > 0 ? multiSelectFields.typeofrights?.map((eachItem) => { return { value: eachItem, label: eachItem } }) : []} />
                </div>
              </div>
              <div className="col-md-4" style={{
                pointerEvents: searchPayload.genreNot?.length > 0 ? "none" : "auto",
                opacity: searchPayload.genreNot?.length > 0 ? 0.5 : 1,
              }}>
                <div className="form-group">
                  <div className="label-toggle">
                    <label htmlFor="example-text-input" className="col-form-label"> Genre</label>

                    {/* <div className="d-flex align-items-center">
                      <label className="toggle-lable">Exclude Selected</label>

                      <label class="toggle">
                        <input type="checkbox" checked={genreExcludeSelected} disabled={searchPayload.genre && searchPayload.genre.length > 0 ? false : true}
                          onChange={handleGenreToggle} />
                        <span class="slider"></span>
                      </label>
                    </div> */}

                  </div>
                  <Select isMulti={true}
                    placeholder='Genre'
                    onChange={(e) => handleMultiSelect(e, "genre")}
                    options={lookup.genre && lookup.genre.map((eachItem) => { return { value: eachItem, label: eachItem }; })}
                    value={multiSelectFields && multiSelectFields.genre && multiSelectFields.genre.length > 0 ? multiSelectFields.genre?.map((eachItem) => { return { value: eachItem, label: eachItem } }) : []} disabled={searchPayload.genreNot?.length > 0} />

                </div>
              </div>
              <div className="col-md-4" style={{ pointerEvents: searchPayload.genre?.length > 0 ? "none" : "auto", opacity: searchPayload.genre?.length > 0 ? 0.5 : 1 }}>
                <div className="form-group">
                  <div className="label-toggle">
                    <label htmlFor="example-text-input" className="col-form-label">Exclude Genre</label>

                    {/* <div className="d-flex align-items-center">
                      <label className="toggle-lable">Exclude Selected</label>

                      <label class="toggle">
                        <input type="checkbox" checked={genreExcludeSelected} disabled={searchPayload.genre && searchPayload.genre.length > 0 ? false : true}
                          onChange={handleGenreToggle} />
                        <span class="slider"></span>
                      </label>
                    </div> */}

                  </div>
                  <Select isMulti={true}
                    placeholder='Genre'
                    onChange={(e) => handleMultiSelect(e, "genreNot")}
                    options={lookup.genre && lookup.genre.map((eachItem) => { return { value: eachItem, label: eachItem }; })}
                    value={multiSelectFields && multiSelectFields.genreNot && multiSelectFields.genreNot.length > 0
                      ? multiSelectFields.genreNot.map((eachItem) => ({ value: eachItem, label: eachItem }))
                      : []}
                    disabled={searchPayload.genre?.length > 0}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="example-text-input" className="col-form-label">Video Quality</label>

                  <Select isMulti={true}
                    placeholder='Video quality'
                    onChange={(e) => handleMultiSelect(e, "videoquality")}
                    options={lookup.videoformat && lookup.videoformat.map((eachItem) => { return { value: eachItem, label: eachItem }; })}
                    value={multiSelectFields && multiSelectFields.videoquality && multiSelectFields.videoquality.length > 0 ? multiSelectFields.videoquality?.map((eachItem) => { return { value: eachItem, label: eachItem } }) : []}
                  />
                </div>
              </div>
              {/* <div className="col-md-4">
  
                  <div className="form-group">
                    <label htmlFor="example-text-input" className="col-form-label">Resolution</label>
  
                    <Select isMulti={true}
                      placeholder='Resolution'
                      onChange={handleChangeresolution}
                      options={resolutionData}
                      value={selectedOptionsresolution}
                    />
                  </div>
                </div> */}
              <div className="col-md-4">



                <div className="form-group">
                  <label htmlFor="example-text-input" className="col-form-label">Certificate</label>

                  <Select isMulti={true}
                    placeholder='Certificate'
                    onChange={(e) => handleMultiSelect(e, "certificate")}
                    options={lookup.certificate && lookup.certificate.map((eachItem) => { return { value: eachItem, label: eachItem }; })}
                    value={multiSelectFields && multiSelectFields.certificate && multiSelectFields.certificate.length > 0 ? multiSelectFields.certificate?.map((eachItem) => { return { value: eachItem, label: eachItem } }) : []}
                  />
                </div>
              </div>
              <div className="col-md-4">


                <div className="form-group">
                  <label htmlFor="example-text-input" className="col-form-label">Territories Available</label>
                  <Select isMulti={true}
                    placeholder='Territories Available'
                    onChange={(e) => handleMultiSelect(e, "territoriesavailable")}
                    options={lookup && lookup.territories && lookup.territories.map((eachItem) => { return { value: eachItem, label: eachItem } })}
                    value={multiSelectFields && multiSelectFields.territoriesavailable && multiSelectFields.territoriesavailable.length > 0 ? multiSelectFields.territoriesavailable?.map((eachItem) => { return { value: eachItem, label: eachItem } }) : []}
                  />


                </div>
              </div>
              <div className="col-md-4">

                <div className="form-group">
                  <label htmlFor="example-text-input" className="col-form-label">Subtitle Languages</label>

                  <Select isMulti={true}
                    placeholder='Subtitles languages'
                    onChange={(e) => handleMultiSelect(e, "subtitleslanguages")}
                    options={lookup.language && lookup.language.map((eachItem) => { return { value: eachItem, label: eachItem }; })}
                    value={multiSelectFields && multiSelectFields.subtitleslanguages && multiSelectFields.subtitleslanguages.length > 0 ? multiSelectFields.subtitleslanguages?.map((eachItem) => { return { value: eachItem, label: eachItem } }) : []}
                  />

                </div>
              </div>
              <div className="col-md-4">

                <div className="form-group">
                  <label htmlFor="example-text-input" className="col-form-label">Release Year</label>
                  <div className="onwards">
                    <input
                      type="number"
                      className="form-control for-clear"
                      id="example-email-input"
                      placeholder="Release year"
                      name="releaseyear"
                      value={searchPayload && searchPayload.releaseyear}
                      onChange={(e) => onChangeSearch(e)}
                    />
                    <span>onwards</span>
                  </div>
                </div>
              </div>
              <div className="col-md-4">

                <div className="form-group">
                  <label htmlFor="example-text-input" className="col-form-label">IMDB Rating</label>

                  <input
                    type="number"
                    className="form-control for-clear"
                    id="example-email-input"
                    placeholder="IMDB Rating"
                    name="IMDBrating"
                    min="1"
                    value={searchPayload && searchPayload.IMDBrating}
                    onChange={(e) => onChangeSearch(e)}
                  />

                </div>
              </div>
              <div className="col-md-4">

                <div className="form-group">
                  <label htmlFor="example-text-input" className="col-form-label">Cast</label>

                  <input
                    type="text"
                    className="form-control for-clear"
                    id="example-email-input"
                    placeholder="Cast"
                    name="cast"
                    value={searchPayload && searchPayload.cast}

                    onChange={(e) => onChangeSearch(e)}
                  />

                </div>
              </div>
              <div className="col-md-4">

                <div className="form-group">
                  <label htmlFor="example-text-input" className="col-form-label">Director</label>

                  <input
                    type="text"
                    className="form-control for-clear"
                    id="example-email-input"
                    placeholder="Director"
                    name="director"
                    value={searchPayload && searchPayload.director}
                    onChange={(e) => onChangeSearch(e)}
                  />

                </div>
              </div>






              {activeFieldsObj.CookingshowActive == true ? (<>

                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="example-text-input" className="col-form-label">Anchor</label>

                    <input
                      type="text"
                      className="form-control for-clear"
                      id="example-email-input"
                      placeholder="Anchor"
                      name="anchor"
                      value={searchPayload && searchPayload.anchor}

                      onChange={(e) => onChangeSearch(e)}
                    />

                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="example-text-input" className="col-form-label">Chef</label>

                    <input
                      type="text"
                      className="form-control for-clear"
                      id="example-email-input"
                      placeholder="Chef"
                      name="chef"
                      value={searchPayload && searchPayload.chef}

                      onChange={(e) => onChangeSearch(e)}
                    />

                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="example-text-input" className="col-form-label">Cuisine</label>

                    <Select isMulti={true}

                      placeholder='Cuisine'
                      onChange={(e) => handleMultiSelect(e, "cuisine")}
                      options={lookup.cuisine && lookup.cuisine && lookup.cuisine.map((eachItem) => { return { value: eachItem, label: eachItem }; })}
                      value={multiSelectFields && multiSelectFields.cuisine && multiSelectFields.cuisine.length > 0 ? multiSelectFields.cuisine?.map((eachItem) => { return { value: eachItem, label: eachItem } }) : []}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="example-text-input" className="col-form-label">Meal Type</label>

                    <input
                      type="text"
                      className="form-control for-clear"
                      id="example-email-input"
                      placeholder="Meal Type"
                      name="mealtype"
                      value={searchPayload && searchPayload.mealtype}

                      onChange={(e) => onChangeSearch(e)}
                    />

                  </div>
                </div>
              </>) : null}
              {activeFieldsObj.SportsActive == true ? (
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="example-text-input" className="col-form-label"> League/Tournament</label>

                    <input
                      type="text"
                      className="form-control for-clear"
                      id="example-email-input"
                      placeholder="League/Tournament"
                      name="league_tournament"
                      value={searchPayload && searchPayload.league_tournament}

                      onChange={(e) => onChangeSearch(e)}
                    />
                  </div>
                </div>
              ) : null}
              {activeFieldsObj.SportsActive == true || activeFieldsObj.LiveEventActive == true ? (<>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="example-text-input" className="col-form-label"> Sports Stars</label>

                    <input
                      type="text"
                      className="form-control for-clear"
                      id="example-email-input"
                      placeholder="Sports Stars"
                      name="sportsstars"
                      value={searchPayload && searchPayload.sportsstars}

                      onChange={(e) => onChangeSearch(e)}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="example-text-input" className="col-form-label">Sports</label>

                    <Select isMulti={true}

                      placeholder='Sports'
                      onChange={(e) => handleMultiSelect(e, "sport")}
                      options={lookup.sports && lookup.sports.map((eachItem) => { return { value: eachItem, label: eachItem }; })}
                      value={multiSelectFields && multiSelectFields.sport && multiSelectFields.sport.length > 0 ? multiSelectFields.sport?.map((eachItem) => { return { value: eachItem, label: eachItem } }) : []}
                    />
                  </div>
                </div>
              </>) : null}
              {activeFieldsObj.LiveEventActive == true || activeFieldsObj.MusicActive == true ? (<>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="example-text-input" className="col-form-label">Band Name</label>

                    <input
                      type="text"
                      className="form-control for-clear"
                      id="example-email-input"
                      placeholder="Band Name"
                      name="bandname"
                      value={searchPayload && searchPayload.bandname}

                      onChange={(e) => onChangeSearch(e)}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="example-text-input" className="col-form-label">Lyricist</label>

                    <input
                      type="text"
                      className="form-control for-clear"
                      id="example-email-input"
                      placeholder="Lyricist"
                      name="lyricist"
                      value={searchPayload && searchPayload.lyricist}

                      onChange={(e) => onChangeSearch(e)}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="example-text-input" className="col-form-label">Music genre</label>

                    <Select isMulti={true}

                      placeholder='Music genre'
                      onChange={(e) => handleMultiSelect(e, "musicgenre")}
                      options={lookup.musicgenre && lookup.musicgenre.map((eachItem) => { return { value: eachItem, label: eachItem }; })}
                      value={multiSelectFields && multiSelectFields.musicgenre && multiSelectFields.musicgenre.length > 0 ? multiSelectFields.musicgenre?.map((eachItem) => { return { value: eachItem, label: eachItem } }) : []}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="example-text-input" className="col-form-label">Other Artists</label>


                    <input
                      type="text"
                      className="form-control for-clear"
                      id="example-email-input"
                      placeholder="Other Artists"
                      name="otherartists"
                      value={searchPayload && searchPayload.otherartists}

                      onChange={(e) => onChangeSearch(e)}
                    />


                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="example-text-input" className="col-form-label">Performance Type</label>

                    <input
                      type="text"
                      className="form-control for-clear"
                      id="example-email-input"
                      placeholder="Performance Type"
                      name="performancetype"
                      value={searchPayload && searchPayload.performancetype}

                      onChange={(e) => onChangeSearch(e)}
                    />


                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="example-text-input" className="col-form-label">Lead Artist</label>

                    <input
                      type="text"
                      className="form-control for-clear"
                      id="example-email-input"
                      placeholder="Lead Artist"
                      name="leadartist"
                      value={searchPayload && searchPayload.leadartist}

                      onChange={(e) => onChangeSearch(e)}
                    />

                  </div>
                </div>
              </>) : null}
              {searchable ? (
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="example-text-input" className="col-form-label">Number Of Episodes</label>
                    <div className="d-flex episodes">
                      <div className="epi-count me-2">
                        <span>Min</span>
                        <input
                          type="number"
                          name="noofepisodesfrom"
                          className=" form-control for-clear"
                          id="input-noofepisodesfrom"

                          // placeholder="Min episodes"
                          value={searchPayload?.noofepisodes?.noofepisodesfrom?.length > 0 && searchPayload?.noofepisodes?.noofepisodesfrom || ""}
                          onChange={(e) => onChangeSearch(e)}
                        />
                      </div>
                      <div className="epi-count">
                        <span>Max</span>
                        <input
                          type="number"
                          name="noofepisodesto"
                          className="form-control for-clear"
                          id="input-noofepisodesto"

                          // placeholder="Max episodes"
                          value={searchPayload?.noofepisodes?.noofepisodesto?.length > 0 && searchPayload?.noofepisodes?.noofepisodesto || ""}
                          onChange={(e) => onChangeSearch(e)}
                        />
                      </div>


                    </div>
                    {errorMsg?.noofepisodesfrom &&
                      <p className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{errorMsg?.noofepisodesfrom}</p>
                    }
                  </div>
                </div>
              ) : null}
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label form-label">Featured</label>
                  <select className="form-select" value={searchPayload.featured === true || searchPayload.featured === false ? searchPayload.featured : ""} placeholder="Featured" name="featured" onChange={(e) => onChangeSearch(e)} >
                    <option value="">Select</option>
                    <option value="true">True</option>
                    <option value="false">False</option>
                  </select>

                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label form-label">STATUS</label>
                  <select className="form-select" placeholder="Status" name="status" value={searchPayload && searchPayload.status ? searchPayload.status : ""} onChange={(e) => onChangeSearch(e)}>
                    <option value="">Select</option>
                    <option value="ACTIVE">ACTIVE</option>
                    <option value="INACTIVE">INACTIVE</option>
                    <option value="INPROGRESS">IN PROGRESS</option>
                    <option value="OFFLINE">OFFLINE</option>
                    <option value="REJECTED">REJECTED</option>


                  </select>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label form-label">Video Available</label>
                  <select className="form-select" placeholder="Status" name="videoAvailable" value={searchPayload.videoAvailable === true || searchPayload.videoAvailable === false ? searchPayload.videoAvailable : ""} onChange={(e) => onChangeSearch(e)}>
                    <option value="">Select</option>
                    <option value="true">True</option>
                    <option value="false">False</option>


                  </select>

                </div>
              </div>





            </div>
          </div>
        </div>

        <div className="adv_footer">


          <button className="fill_btn yellow-gradient reset-btn" onClick={clearSearch}><span className="material-icons-outlined">sync</span>Reset</button>


          <button className={`fill_btn yellow-gradient float-end ${Object.keys(searchPayload).length == 0 ? "disable" : ""}`} disabled={Object.keys(searchPayload).length == 0} onClick={searchSubmit}>
            {loaderEnable ? (<img src="https://d9nwtjplhevo0.cloudfront.net/orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg" className="loading-icon" />) : null}SEARCH
          </button>

          <div className="clearfix"></div>
        </div>
      </div >


    </>
  );
};

export default AdvanceSearch;
